<template>

    <div class="fetch-container">


        <!--STEP LOADING-->


        <transition name="hide-anim">


            <div v-if="loading && !error" class="loading-container desktop-width">

                <tips-fetch v-if="loading"></tips-fetch>


                <div class="flex-collumn">

                    <lottie-loader class="loader-margin"></lottie-loader>

                    <p class="loading-title">{{ $t('fetch_title') }}</p>

                    <p class="loading-subtitle">{{ $t('fetch_description') }}</p>

                    <scrolling-senders :sender="cache"></scrolling-senders>

                </div>

                <div class="loading-bottom-container">

                    <div :class="{ 'ghost-bloc': !showCheckboxNotif}" class="bloc-bottom">

                        <div class="stage-2">

                            <div class="stage-2-left">

                                <p class="bottom-sheet-title">{{ $t('fetch_switch_title') }}</p>

                                <p class="bottom-sheet-subtitle">{{ $t('fetch_switch_description') }}</p>

                            </div>

                            <div>

                                <checkbox-circle
                                    :state="checkboxState"
                                    @change="notifCheckUpdate"
                                ></checkbox-circle>

                            </div>


                        </div>

                    </div>

                    <p class="cf-caption-1 pointer" @click="goSettings">{{ $t('fetch_settings') }}</p>

                </div>

            </div>

        </transition>

        <!--ERROR STEP-->
        <transition>

            <div v-if="afterError" class="final-container desktop-width">


                <div></div>

                <div class="final-middle-container">

                    <img class="lottie-check-container" src="/img/icons/alert-white-back-blue.svg">

                    <div class="final-middle-text-container">


                        <p class="final-title">{{ $t('fetch_error_title') }}</p>

                        <p class="final-subtitle">{{ $t('fetch_error_text') }}</p>

                    </div>


                </div>

                <div class="final-button-container full">

                    <button class="btn btn-dark btn-big" @click="restart">{{ $t('fetch_error_cta') }}</button>

                </div>

            </div>


        </transition>

        <!--FINAL STEP-->
        <transition name="show-anim">

            <div v-if="afterLoading && !error" class="final-container desktop-width">

                <div class="ghost"></div>

                <div class="final-middle-container">

                    <div class="lottie-check-container">

                        <lottie-check v-if="lottieCheckDelay"></lottie-check>

                    </div>

                    <div class="final-middle-text-container">

                        <p class="final-title">{{ $t('fetch_done_title') }}</p>

                        <p class="final-subtitle">{{ $t('fetch_done_description') }}</p>

                    </div>

                </div>

                <div class="final-bottom-container">

                    <div class="final-button-container">

                        <img class="fetch-foxy" src="/img/foxy/middle-smile.png">

                        <button class="btn btn-dark btn-big" @click="goClean">{{ $t('global_cta_clean') }}</button>

                    </div>

                </div>

            </div>

        </transition>

        <bottom-sheet-fetch-notifications ref="btmsht" @permissionResponse="permissionResponseFromBottomSheet"></bottom-sheet-fetch-notifications>

        <bottom-sheet-accept-notifications ref="btmshtAccept"></bottom-sheet-accept-notifications>

        <bottom-sheet-refuse-notifications ref="btmshtRefuse"></bottom-sheet-refuse-notifications>

    </div>

</template>

<script>
import Api from '@/api'

import Storage from '@/helpers/storage'

import BottomSheetAcceptNotifications from '@/components/bottomSheet/BottomSheetAcceptNotifications'
import BottomSheetFetchNotifications from '@/components/bottomSheet/BottomSheetFetchNotifications'
import BottomSheetRefuseNotifications from '@/components/bottomSheet/BottomSheetRefuseNotifications'
import CheckboxCircle from '@/components/inputs/CheckboxCircle'
import LottieLoader from '@/components/lottie/LottieLoader'
import LottieCheck from '@/components/lottie/LottieCheck'
import ScrollingSenders from '@/components/ScrollingSenders.vue'
import TipsFetch from '@/components/TipsFetch'

import I18n from '@/modules/i18n'
import Loop from '@/modules/loop'
import Notifs from '@/modules/notifications'
import Tag from '@/modules/tag'
import UserFlow from '@/modules/userFlow'

export default {

    name: 'fetch',

    components: {BottomSheetAcceptNotifications, BottomSheetFetchNotifications, BottomSheetRefuseNotifications, CheckboxCircle, LottieLoader, LottieCheck, ScrollingSenders, TipsFetch},

    watch: {

        loading: function (loading) {

            if (!loading) {

                const self = this

                // delay before loading dissmiss
                setTimeout(function () {
                    self.afterLoading = true
                }, 500)

                // delay before lottie check anim
                setTimeout(function () {
                    self.lottieCheckDelay = true
                }, 1000)

            } else {

                this.lottieCheckDelay = false
                this.afterLoading = false
                this.error = false
            }
        },

        error: function (error) {

            if (error) {

                Tag.pageViewAmplitude(this, 'fetch_error')

                const self = this

                // delay before loading dissmiss
                setTimeout(function () {
                    self.afterError = true
                }, 600)

            } else {

                this.lottieCheckDelay = false
                this.afterLoading = false
                this.afterError = false
            }
        }

    },

    data() {
        return {
            queu: [],
            senderList: [],
            maxSenders: 4,
            haveSubscription: false,
            subscriptions: false,
            afterLoading: false,
            lottieCheckDelay: false,
            mySet: new Set(),
            cache: '',
            loading: true,
            error: false,
            afterError: false,
            notifEmail: false,
            showCheckboxNotif: false,
            checkboxState: false,
            fetchLoopFirstTime: true
        }
    },

    created() {
        UserFlow.setPage(this, 'fetch')
    },

    mounted() {

        Storage.setItem('fetchStatus', 'processing')
        if (this.$mq === 'lg') {
            this.maxSenders = 5
        }

        Tag.pageViewGA(this, 'fetch')

        this.notifEmailLanguage()

        this.fetch()

        this.startSendersScrawl()
    },

    methods: {

        mustAskPermission() {

            return Notifs.permission() !== 'denied' && !Storage.getItem('firebaseAppInstanceId')
        },

        restart() {

            this.queu = []
            this.senderList = []
            this.maxSenders = 4
            this.haveSubscription = false
            this.subscriptions = false
            this.afterLoading = false
            this.lottieCheckDelay = false
            this.mySet = new Set()
            this.cache = ''
            this.loading = true
            this.error = false
            this.afterError = false

            this.fetch()

        },

        permissionResponseFromBottomSheet(permission) {

            switch (permission) {
                case 'granted':
                    this.showCheckboxNotif = false
                    this.$refs.btmshtAccept.open()
                    break
                case 'default':
                    this.showCheckboxNotif = true
                    break
                case 'denied':
                    this.showCheckboxNotif = true
                    this.$refs.btmshtRefuse.open()
                    break
            }

        },

        startSendersScrawl() {

            const self = this

            setInterval(function () {

                if (self.queu[0]) {

                    self.cache = self.cache === '' ? self.queu.shift() : ''

                }

            }, 1000)

        },

        asyncFetchMeantime(data) {

            if (this.fetchLoopFirstTime) {
                if (!data.done && this.mustAskPermission()) {

                    this.$refs.btmsht.open()

                }
                this.fetchLoopFirstTime = false
            }

            if (data && data.samples && data.samples.length) {

                this.fillQueue(data.samples.map(senders => senders.sender))

                this.queu.push()
            }

            if (data.subscriptions && data.subscriptions.length > 0) {

                this.fillQueue(data.subscriptions.map(senders => senders.sender))

                this.subscriptions = true

            }

        },

        fillQueue(senders) {

            senders.forEach(sender => {

                if (!this.mySet.has(sender)) {

                    this.mySet.add(sender)

                    this.queu.push(sender)

                }

            })

        },

        fetch() {

            Loop.start(Api.newsletters.get, this.asyncFetchMeantime)
                .then(() => {

                    this.fetchDone()

                })
                .catch(error => {

                    if (error.code >= 500) {

                        this.error = true

                    } else {

                        this.restart()

                    }

                })

        },

        fetchDone() {

            Storage.setItem('fetchStatus', 'done')

            this.loading = false

            Tag.pageViewAll(this, 'fetch_done')

        },

        goClean() {

            Tag.clickGA(this, 'next')

            this.$router.push({path: '/newsletters'})

        },

        goSettings() {

            Tag.clickGA(this, 'settings')
            this.$router.push({path: '/settings'})

        },

        notifCheckUpdate(bool) {

            if (Notifs.permission() !== 'denied') {

                Notifs.update({important: bool, news: bool})
                    .then(settings => {
                        this.checkboxState = settings.notifications.push.news || settings.notifications.push.important
                    })
                    .catch(() => {
                        this.checkboxState = false
                    })

            } else {

                this.$refs.btmshtRefuse.open()

            }

        },

        notifEmailLanguage() {

            Api.user.updateFetchLanguage(I18n.get(this))
                .catch(() => {
                })

        }
    }
}
</script>

<style lang="scss" scoped>

.fetch-container {
    max-height: 100vh;
    position: relative;
    background-image: url('/img/background/fetch-mobile.svg');
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: cover;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    color: $white;
    align-items: center;
    justify-content: center;
    padding: 16px;
    @media screen and (min-width: $above-tablet-length) {
        padding: 32px;
        background-image: url('/img/background/fetch-desktop.svg');
    }
}

.desktop-width {
    @media screen and (min-width: $above-tablet-length) {
        max-width: 501px;
    }
}

.loading-container {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}

.loader-margin {
    margin-top: 60px;
}

.loading-title {
    font-size: 22px;
    font-weight: bold;
    line-height: 1.27;
    letter-spacing: -0.2px;
    margin-top: 23px;
    @media screen and (min-width: $above-tablet-length) {
        font-size: 28px;
        line-height: 1.14;
    }
}

.loading-subtitle {
    font-size: 12px;
    line-height: 1.33;
    @media screen and (min-width: $above-tablet-length) {
        font-size: 17px;
        font-weight: 500;
        line-height: 1.41;
    }
}

.sender-text {
    font-size: 11px;
    line-height: 1.45;
    overflow: hidden;
    height: 20px;
    @media screen and (min-width: $above-tablet-length) {
        font-size: 15px;
        font-weight: 500;
        line-height: 1.33;
    }
}

.loading-bottom-container {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.bloc-bottom {
    width: 100%;
    background-color: $white;
    padding: 24px 16px;
    border-radius: 12px;
    color: $midnight;
    margin-bottom: 8px;
}

.ghost-bloc {
    visibility: hidden;
}

.stage-2 {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    align-content: center;
}

.stage-2-left {
    text-align: left;
}

.bottom-sheet-title {
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.31;
    letter-spacing: normal;
    color: $midnight;
}

.bottom-sheet-subtitle {
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
    color: $midnight;
}

.fetch-arrow {
    transform: rotate(180deg);
    width: 24px;
    height: 24px;
}

.final-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    flex-grow: 1;
}

.final-middle-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.lottie-check-container {
    height: 40px;
    object-fit: contain;
}

.fetch-blue-circle {
    width: 40px;
    height: 40px;
    background-color: #94d5ff;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.final-icon {
    width: 24px;
    object-fit: contain;
}

.final-middle-text-container {
    margin-top: 23px;
}

.final-title {
    font-size: 22px;
    font-weight: bold;
    line-height: 1.27;
    letter-spacing: -0.2px;
    @media screen and (min-width: $above-tablet-length) {
        font-size: 28px;
        line-height: 1.14;
    }
}

.final-subtitle {
    font-size: 12px;
    line-height: 1.33;
    @media screen and (min-width: $above-tablet-length) {
        font-size: 17px;
        font-weight: 500;
        line-height: 1.41;
    }
}

.final-bottom-container {
    width: 100%;
}

.final-button-container {
    display: flex;
    position: fixed;
    bottom: 16px;
    left: 16px;
    right: 16px;
    @media screen and (min-width: $above-tablet-length) {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.fetch-foxy {
    height: 87px;
    object-fit: contain;
    position: absolute;
    top: -79px;
}

.anim-senders-show {
    animation: senderShowAnim 2s ease-in-out 0s infinite;
}

@keyframes senderShowAnim {

    0% {
        height: 0;
        opacity: 0;
    }

    20% {
        height: 20px;
        opacity: 0;
    }

    30% {
        height: 20px;
        opacity: 1;
    }


    100% {
        height: 20px;
        opacity: 1;
    }
}

.hide-anim-leave-active {
    animation: anim-hide .6s
}

@keyframes anim-hide {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

.show-anim-enter-active {
    opacity: 0;
    animation: anim-show .2s linear 0;
}

@keyframes anim-show {
    0% {
        opacity: 0;
        height: 100%;
    }

    100% {
        opacity: 1;
    }
}

</style>
